export const headerTexts = {
  en: {
    home: "Home",
    services: "Services",
    community: "Community",
    places: "Discover Local Spots",
    about: "About Us",
    register: "Register",
    professionals: "Professionals"
  },
  pt: {
    home: "Início",
    services: "Serviços",
    community: "Comunidade",
    places: "Locais Brasileiros",
    about: "Sobre Nós",
    register: "Cadastro",
    professionals: "Profissionais"
  },
};

export const footerTexts = {
  en: {
    location: "Berlin, Germany",
    whatsapp: "Chat on WhatsApp",
    instagram: "Instagram",
    email: "hello.genauhub@gmail.com",
    sections: {
      genauhub: "Genau Hub",
      about: "About us",
      services: "Services",
      community: "Community",
      membership: "Membership",
      register: "Register a Service",
      explore: "Explore",
      localPlaces: "Local Places",
      professionals: "Professionals"
    },
    copyright: "All rights reserved.",
    terms: "Terms of Use",
    imprint: "Impressum",
    privacy: "Privacy Policy",
    dataRequest: "Data Request",
    dataRequestMailSubject: "Data Request - Genauhub",
    dataRequestMailBody:
      "Hello,%0A%0AI want to request access/correction/deletion of my personal data.%0A%0AName:%0AEmail:%0ARequest details:%0A%0AThanks.",
  },
  pt: {
    location: "Berlim, Alemanha",
    whatsapp: "Falar no WhatsApp",
    instagram: "Instagram",
    email: "hello.genauhub@gmail.com",
    sections: {
      genauhub: "Genau Hub",
      about: "Sobre nós",
      services: "Serviços",
      community: "Comunidade",
      membership: "Membros",
      register: "Cadastrar um Serviço",
      explore: "Explorar",
      localPlaces: "Locais Brasileiros",
      professionals: "Profissionais"
    },
    copyright: "Todos os direitos reservados.",
    terms: "Termos de uso",
    imprint: "Impressum",
    privacy: "Política de Privacidade",
    dataRequest: "Solicitar dados",
    dataRequestMailSubject: "Solicitacao de Dados - Genauhub",
    dataRequestMailBody:
      "Ola,%0A%0AGostaria de solicitar acesso/correcao/exclusao dos meus dados pessoais.%0A%0ANome:%0AEmail:%0ADetalhes do pedido:%0A%0AObrigado.",
  },
};

export const servicesBreadcrumbTranslations = {
  en: {
    home: "Home",
    services: "Services",
    professionals: "Professionals"
  },
  pt: {
    home: "Início",
    services: "Serviços",
    professionals: "Profissionais"
  },
};

export const serviceOfferTranslations = {
  en: {
    heading: "Are you a Brazilian offering a service?",
    subtext: "Get listed here and help others in the community find you.",
    button: "Get Listed",
  },
  pt: {
    heading: "Você é um brasileiro oferecendo um serviço?",
    subtext: "Cadastre-se aqui e ajude outros da comunidade a te encontrarem.",
    button: "Cadastrar serviço",
  },
};

export const whatsAppTranslations = {
  en: {
    title: "Prefer to register or chat on WhatsApp?",
    description: "Click the button below to start a conversation!",
    button: "Chat on WhatsApp"
  },
  pt: {
    title: "Prefere se registrar ou conversar pelo WhatsApp?",
    description: "Clique no botão abaixo para iniciar uma conversa!",
    button: "Conversar no WhatsApp"
  }
}